import { IMessageType } from '../types';

import { IFacilitySearchReqMsg } from '~/api/messages/IFacilitySearchReqMsg';
import { IFacilitySearchRespMsg } from '~/api/messages/IFacilitySearchRespMsg';

export const FacilitySearchReqMsg: IMessageType<IFacilitySearchReqMsg, IFacilitySearchRespMsg> = {
  requestName: 'FacilitySearchReqMsg',
  responseName: 'FacilitySearchRespMsg',
};
